export default __webpack_public_path__ + "static/media/693.de7f7083.gif";